var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgJavascriptLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H96.068V96.068H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2594 80.2806L32.6112 75.8314C34.0295 78.3461 35.3197 80.4738 38.4145 80.4738C41.381 80.4738 43.2513 79.3133 43.2513 74.7997V44.1036H52.2792V74.9273C52.2792 84.2779 46.7982 88.534 38.8015 88.534C31.5795 88.534 27.3873 84.7936 25.2593 80.2798",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1829 79.3136L64.5337 75.0575C66.4688 78.2177 68.9838 80.539 73.4331 80.539C77.1738 80.539 79.5592 78.6687 79.5592 76.0892C79.5592 72.9938 77.1089 71.8975 72.9816 70.0924L70.7252 69.1244C64.2117 66.352 59.8909 62.8698 59.8909 55.5182C59.8909 48.747 65.0498 43.5879 73.1109 43.5879C78.8503 43.5879 82.9774 45.5872 85.9435 50.8107L78.9144 55.3245C77.3666 52.5518 75.6904 51.4557 73.1111 51.4557C70.4671 51.4557 68.7903 53.1323 68.7903 55.3245C68.7903 58.033 70.4671 59.1296 74.3359 60.8063L76.5927 61.7736C84.2667 65.0626 88.5875 68.4155 88.5875 75.9602C88.5875 84.086 82.2034 88.5352 73.6268 88.5352C65.2436 88.5352 59.8264 84.5373 57.1829 79.3136Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.068,
    height: 96.068,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgJavascriptLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/javascriptLogo.556321bc.svg";
export { ForwardRef as ReactComponent };